export default __webpack_public_path__ + "static/media/E-S main cover.3d1e60d7.jpg";